import React from 'react'

export default function PiePagina() {
  return (
    <footer className='sticky-footer bg-white'>
      <div className='container my-auto'>
        <div className='copyright text-center my-auto'>
          <span>Copyright © UNAD 2020</span>
        </div>
      </div>
    </footer>
  )
}
